import React from "react";
import ReactDOM from "react-dom/client";
import App from "./App";
import { BrowserRouter } from "react-router-dom";
import NewCitizenContextProvider from "../src/pages/Register/Form/NewCitizenContext";
import QrScannerProvider from "pages/QRScan/Provider";
import SearchProvider from "pages/Search/SearchContext";
import CitizenEditProvider from "pages/Edit/Form/CitizenEditContext";
import AuthProvider from "auth/Provider";
import { ConfigProvider } from "providers/ConfigProvider";
import { Toaster } from "react-hot-toast";
import SocialServiceProvider from "pages/SocialService/Provider";

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <Toaster position="top-center"   />
    <ConfigProvider>
      <AuthProvider>
        <BrowserRouter>
          <NewCitizenContextProvider>
            <CitizenEditProvider>
              <QrScannerProvider>
                <SocialServiceProvider>
                  <SearchProvider>
                    <App />
                  </SearchProvider>
                </SocialServiceProvider>
              </QrScannerProvider>
            </CitizenEditProvider>
          </NewCitizenContextProvider>
        </BrowserRouter>
      </AuthProvider>
    </ConfigProvider>
  </React.StrictMode>,
);
